// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__3AWTZ","bookNowBtnStyle":"AboutUs_bookNowBtnStyle__jb505","footerStyle":"AboutUs_footerStyle__Q2UB7"};